import { TextField } from 'formik-material-ui'
import { FieldProps } from "formik";
import React from "react";

// README: this file is for small UI elements that do not have any custom code
// more complex UI should go in its own file

// creating a custom Formik component that works with typescript. See https://github.com/formium/formik/issues/2780
export const MultiLineTextField: React.FC<FieldProps> = ({
    field, // { name, value, onChange, onBlur }
    form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    //type = "text",
    ...props
}) => (
    <TextField rows={3} multiline variant='outlined' style={{ width: '75ch' }} field={field} form={form} {...props} />
)

export const ReadonlyTextField: React.FC<FieldProps> = ({
    field, // { name, value, onChange, onBlur }
    form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    //type = "text",
    ...props
}) => (
    <TextField InputProps={{ readOnly: true }} field={field} form={form} {...props} />
)